export default __webpack_public_path__ + "static/media/random-v.26eb7dd4.jpg";